// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-TermsLink__wrapper","inline":"c-TermsLink__inline","block":"c-TermsLink__block","link":"c-TermsLink__link"};